import React, { useState } from 'react';
import Sidebar from './components/sidebar';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';

const Contactanos = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    asunto: '',
    mensaje: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const contactar = async (datos) => {
    setLoading(true);
    setError(null);
    setSubmitted(false);
    
    try {
      await axios.post('https://mrcirp.com/api/contacto.php', datos, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      // Si no hubo error en la petición, consideramos que se envió correctamente
      setSubmitted(true);
      setFormData({
        nombre: '',
        email: '',
        asunto: '',
        mensaje: ''
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Error de conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    contactar(formData);
  };

  return (
    <Sidebar>
      <Container className="mt-4 mb-5">
        <Row className="mb-4">
          <Col>
            <h1 className="text-center">Contáctanos</h1>
            <p className="text-center text-muted">
              ¿Tienes preguntas? Escríbenos y te responderemos lo antes posible.
            </p>
          </Col>
        </Row>

        {error && (
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {submitted && (
          <Row className="justify-content-center">
            <Col md={8}>
              <div className="text-center text-success">
                <h4>¡Mensaje enviado con éxito!</h4>
                <p className="mb-0">
                  Nos pondremos en contacto contigo pronto. Gracias por escribirnos.
                </p>
              </div>
            </Col>
          </Row>
        )}
        
        {!submitted && (
          <Row>
            {/* Formulario de contacto */}
            <Col md={7} className="mb-4">
              <Card className="shadow-sm">
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group controlId="formName">
                          <Form.Label>Nombre completo</Form.Label>
                          <Form.Control 
                            type="text" 
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            placeholder="Ingresa tu nombre" 
                            required 
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group controlId="formEmail">
                          <Form.Label>Correo electrónico</Form.Label>
                          <Form.Control 
                            type="email" 
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="ejemplo@correo.com" 
                            required 
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group controlId="formSubject" className="mb-3">
                      <Form.Label>Asunto</Form.Label>
                      <Form.Control 
                        type="text" 
                        name="asunto"
                        value={formData.asunto}
                        onChange={handleChange}
                        placeholder="¿Sobre qué quieres contactarnos?" 
                        required 
                      />
                    </Form.Group>

                    <Form.Group controlId="formMessage" className="mb-3">
                      <Form.Label>Mensaje</Form.Label>
                      <Form.Control 
                        as="textarea" 
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={handleChange}
                        rows={5} 
                        placeholder="Escribe tu mensaje aquí..." 
                        required 
                      />
                    </Form.Group>

                    <div className="d-grid">
                      <Button variant="primary" type="submit" disabled={loading}>
                        <FaPaperPlane className="me-2" />
                        {loading ? 'Enviando...' : 'Enviar mensaje'}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            {/* Información de contacto */}
            <Col md={5}>
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <h5 className="mb-4">Información de contacto</h5>
                  
                  <div className="d-flex mb-4">
                    <div className="me-3 text-primary">
                      <FaEnvelope size={24} />
                    </div>
                    <div>
                      <h6>Correo electrónico</h6>
                      <p className="text-muted mb-0">contacto@mrcirp.com</p>
                      <p className="text-muted">soporte@mrcirp.com</p>
                    </div>
                  </div>

                  <div className="d-flex mb-4">
                    <div className="me-3 text-primary">
                      <FaPhone size={24} />
                    </div>
                    <div>
                      <h6>Teléfono</h6>
                      <p className="text-muted mb-0">(123) 456-7890</p>
                      <p className="text-muted">(123) 654-3210</p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="me-3 text-primary">
                      <FaMapMarkerAlt size={24} />
                    </div>
                    <div>
                      <h6>Dirección</h6>
                      <p className="text-muted mb-0">
                        Costa Rica
                      </p>
                      <p className="text-muted">Costa Rica</p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <h6>Horario de atención</h6>
                    <p className="text-muted mb-0">Lunes a Viernes: 9:00 am - 6:00 pm</p>
                    <p className="text-muted">Sábados: 10:00 am - 2:00 pm</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </Sidebar>
  );
};

export default Contactanos;